import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MessagesType } from '@src/store/ducks/app/types'

export const initialState = {
  isInitialized: false,
  pageTitle: 'КОСМОС Телеком',
  isHeader: true,
  messages: {} as MessagesType,
  isEditName: false,
  dataGamePage: {},
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsInitialized(state) {
      state.isInitialized = true
    },
    setPageTitle(state, { payload }: PayloadAction<string>) {
      state.pageTitle = payload
    },
    setIsHeader(state, { payload }: PayloadAction<boolean>) {
      state.isHeader = payload
    },
    setMessages(state, { payload }: PayloadAction<MessagesType>) {
      state.messages = payload
    },
    setIsEditName(state, { payload }: PayloadAction<boolean>) {
      state.isEditName = payload
    },
    setDataGamePage(state, { payload }) {
      state.dataGamePage = payload
    },
  },
})

export type AppStateType = typeof initialState

export const {
  setIsInitialized,
  setPageTitle,
  setIsHeader,
  setMessages,
  setIsEditName,
  setDataGamePage,
} = appSlice.actions
export const appReducer = appSlice.reducer
